import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { Servers } from '../../utils/api/servers'
import { axiosFetcher, type AxiosFetcherKey } from '../../utils/api/axios-fetcher'
import { type PortfolioExposureData } from '../../models/exposure/exposure-types'

export function useExposureSnapshots (isAuthorized: boolean, accessToken: string | null, after: string): Record<number, PortfolioExposureData> {
  const [exposureSnapshots, setExposureSnapshots] = useState<Record<number, PortfolioExposureData>>({})

  const { data, error } = useSWR<Record<number, PortfolioExposureData>, boolean, AxiosFetcherKey>(
    isAuthorized ? [Servers.STRATEGY_GATEWAY, null, 'risk-management/portfolio-exposure', accessToken, { 'axios-timestamp': '', after }] : null,
    axiosFetcher,
    {
      refreshInterval: 300000,
    }
  )

  useEffect(() => {
    if (data == null || (error === true)) {
      setExposureSnapshots({})
    } else {
      setExposureSnapshots(data)
    }
  }, [data, error])

  return exposureSnapshots
}
